
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Truck } from 'lucide-react';

interface CashOnDeliveryMethodProps {
  enabled: boolean;
  onToggle: (checked: boolean) => void;
  disabled: boolean;
}

export const CashOnDeliveryMethod: React.FC<CashOnDeliveryMethodProps> = ({
  enabled,
  onToggle,
  disabled
}) => {
  return (
    <div className="flex items-center justify-between p-4 border rounded-lg">
      <div className="flex items-center space-x-3">
        <div className="p-2 rounded-full bg-amber-100">
          <Truck className="h-5 w-5 text-amber-600" />
        </div>
        <div>
          <h3 className="font-medium">Paiement à la livraison</h3>
          <p className="text-sm text-muted-foreground">
            Vos clients paieront à la livraison de leur commande
          </p>
        </div>
      </div>
      <Switch 
        checked={enabled}
        onCheckedChange={onToggle}
        disabled={disabled}
      />
    </div>
  );
};
